/** @license MIT License (c) copyright 2010-2017 original author or authors */
/** @author Brian Cavalier */
/** @author John Hann */

export function thru (f, stream) {
  return f(stream)
}



//////////////////
// WEBPACK FOOTER
// ./~/most/src/combinator/thru.js
// module id = 656
// module chunks = 0